window.Products.Clothing.ClassicZipperHoodie = function() {
};
window.Products.Clothing.ClassicZipperHoodie.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.ClassicZipperHoodie.dpi = 150;
window.Products.Clothing.ClassicZipperHoodie.has_3d = true;
window.Products.Clothing.ClassicZipperHoodie.id = 111;
window.Products.Clothing.ClassicZipperHoodie.slug = 'classic-zipper-hoodie';
window.Products.Clothing.ClassicZipperHoodie.syncColors = true;
window.Products.Clothing.ClassicZipperHoodie.texturesLoaded = 0;
window.Products.Clothing.ClassicZipperHoodie.texturesLoading = false;
window.Products.Clothing.ClassicZipperHoodie.use_glb = true;

window.Products.Clothing.ClassicZipperHoodie.prototype.outsideObject = 0;
window.Products.Clothing.ClassicZipperHoodie.prototype.detailsObject = 1;
window.Products.Clothing.ClassicZipperHoodie.prototype.position = 0;

window.Products.Clothing.ClassicZipperHoodie.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	var three_intensity = 1.0;
	if(color.includes("heather") || color == "sport_grey"){
		three_intensity = 3;
		three_color.multiplyScalar(0.9);
	}
	object.children[0].children[me.detailsObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);
	
	object.children[0].children[me.outsideObject].material.aoMapIntensity = three_intensity;
	object.children[0].children[me.detailsObject].material.aoMapIntensity = three_intensity / 10;
};

window.Products.Clothing.ClassicZipperHoodie.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"cardinal_red": 0x6b1a2b,
		"dark_heather": 0x45434c,
		"carolina_blue": 0x8aa3db,
		"irish_green": 0x337e44,
		"navy": 0x2e3142,
		"royal": 0x39549b,
		"safety_green": 0xcad843,
		"safety_orange": 0xd1430f,
		"sport_grey": 0x9a9a9a,
		"purple": 0x3b2a61,
	};

	return new THREE.Color(colors[_name]);
};